import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {CommonService} from "../services/common.service";
import {FormGroup} from "@angular/forms";

@Directive({
  selector: '[appInputRestriction]'
})
export class InputRestrictionDirective {
  inputElement: ElementRef;
  @Input() appInputRestriction: string = '';
  @Input('parentFormGroup') parentFormGroup: FormGroup = new FormGroup<any>({});
  @Input('controlName') controlName: string = '';

  alphabetRegex = new RegExp(/[A-Za-z]/);
  noUpperCaseAlphabetsRegex = new RegExp(/^(?!.*[A-Z]).*$/);
  digitsRegex = new RegExp(/\d/);
  specialCharsRegex = new RegExp(/[\[\]/$&+,:;=?@#|'<>.^*()%!\-_]/);

  onlyAlphabetsRegex = new RegExp(/(\W)/, 'g');
  onlyDigitsRegex = new RegExp(/\D/, 'g');
  noSpecialCharactersRegex = new RegExp(/[\[\]/$&+,:;=?@#|'<>.^*()%!\-_ ]/, 'g');

  constructor(
    el: ElementRef,
    private commonService: CommonService
  ) {
    this.inputElement = el;
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: any) {
    switch (this.appInputRestriction) {
      case 'onlyInteger':
        this.integerOnly(event);
        break;
      case 'noSpecialChars':
        this.noSpecialChars(event);
        break;
      case 'onlyAlphabets':
        this.onlyAlphabets(event);
        break;
      case 'noUpperCaseAlphabets':
        this.noUpperCaseAlphabets(event);
        break;
    }
  }

  onlyAlphabets(event: KeyboardEvent) {
    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === 65 && e.ctrlKey) ||
      (e.keyCode === 67 && e.ctrlKey) ||
      (e.keyCode === 86 && e.ctrlKey) ||
      (e.keyCode === 88 && e.ctrlKey)) {
      // let it happen, don't do anything
      return;
    }

    if (!this.alphabetRegex.test(e.key)) {
      e.preventDefault();
    }
  }

  noUpperCaseAlphabets(event: KeyboardEvent) {
    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === 65 && e.ctrlKey) ||
      (e.keyCode === 67 && e.ctrlKey) ||
      (e.keyCode === 86 && e.ctrlKey) ||
      (e.keyCode === 88 && e.ctrlKey)) {
      // let it happen, don't do anything
      return;
    }

    if (!this.noUpperCaseAlphabetsRegex.test(e.key)) {
      e.preventDefault();
    }
  }

  integerOnly(event: KeyboardEvent) {
    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === 65 && e.ctrlKey) ||
      (e.keyCode === 67 && e.ctrlKey) ||
      (e.keyCode === 86 && e.ctrlKey) ||
      (e.keyCode === 88 && e.ctrlKey)) {
      // let it happen, don't do anything
      return;
    }

    if (!this.digitsRegex.test(e.key)) {
      e.preventDefault();
      return;
    }
  }

  noSpecialChars(event: KeyboardEvent) {
    const e = <KeyboardEvent>event;
    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    let k;
    k = event.keyCode;  // k = event.charCode;  (Both can be used)
    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57)) {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.commonService.alphanumericRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }
  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    let regex;

    if (this.appInputRestriction === 'onlyInteger') {
      regex = this.onlyDigitsRegex;
    } else if (this.appInputRestriction === 'noSpecialChars') {
      regex = this.noSpecialCharactersRegex;
    } else if (this.appInputRestriction === 'onlyAlphabets') {
      regex = this.onlyAlphabetsRegex;
    }

    if (this.appInputRestriction === 'noUpperCaseAlphabets') {
      const e = <ClipboardEvent>event;
      let pasteData = e.clipboardData?.getData('text/plain') || '';
      pasteData = pasteData.toLowerCase();
      this.parentFormGroup.controls[this.controlName].patchValue(pasteData, {emitEvent: false});
      e.preventDefault();
      return;
    }

    if (regex) {
      const e = <ClipboardEvent>event;
      let pasteData = e.clipboardData?.getData('text/plain') || '';
      pasteData = pasteData.replaceAll(regex, '');

      this.parentFormGroup.controls[this.controlName].patchValue(pasteData, {emitEvent: false})
      e.preventDefault();
    }
  }

  @HostListener('input') onInput() {
    if (this.appInputRestriction === 'noUpperCaseAlphabets') {
      const el = this.inputElement.nativeElement;
      const current = el.value;
      const lowered = current.toLowerCase();
      if (current !== lowered) {
        const start = el.selectionStart;
        const end = el.selectionEnd;
        this.parentFormGroup.controls[this.controlName].patchValue(lowered, {emitEvent: false});
        el.value = lowered;
        el.setSelectionRange(start, end);
      }
    }
  }
}
